module.exports = __webpack_public_path__ + "img/img25.8ff5bab4.svg";